// TODO: delete this file
export const JUMBO_TABLES = {
  LIFELINE_EVENTS: 'lifeline_events',
};

export const isLogging = () => {
  return process.env.NODE_ENV === 'production';
};

const jumbo = {
  sendPageView: (...args) => {},
  sendToJumbo: (...args) => {},
  setParams: (...args) => {},
};

export const sendEventToJumbo = (event_name, response_meta, request_meta) => {
  if (!isLogging()) return;
  const dummyData = { response: 'success' };
  const jumbo_data = {
    ename: event_name,
    response_meta: response_meta || dummyData,
    request_meta: request_meta || dummyData,
  };

  jumbo.sendToJumbo(JUMBO_TABLES.LIFELINE_EVENTS, jumbo_data);
};

export const sendPageViewToJumbo = (pageUrl) => {
  if (!isLogging()) return;
  jumbo.sendPageView(pageUrl);
};

export const sendParamsToJumbo = (params) => {
  if (!isLogging()) return;
  jumbo.setParams(params);
};
